import { CheckCircle, Circle, Clock } from 'lucide-react';

// Simplified operational workflow
const statusSteps = [
  'Submitted',
  'Quoted',
  'Dispatched',
  'Picked Up',
  'Delivered',
  'Returned',
  'Completed'
];

// Map legacy statuses to the new workflow positions
const mapLegacyStatus = (status) => {
  const legacyMap = {
    'Submitted – Pending DLT Approval': 'Submitted',
    'Pending Approval': 'Submitted',
    'Rate Requested': 'Submitted',
    'Under Review': 'Submitted',
    'Approved': 'Quoted',
    'Booked': 'Dispatched',
    'At Terminal': 'Dispatched',
    'Invoiced': 'Completed',
    'Paid': 'Completed'
  };
  return legacyMap[status] || status;
};

export const ShipmentTimeline = ({ currentStatus }) => {
  const mappedStatus = mapLegacyStatus(currentStatus);
  const currentIndex = statusSteps.indexOf(mappedStatus);
  const actualIndex = currentIndex === -1 ? 0 : currentIndex;

  return (
    <div className="relative" data-testid="shipment-timeline">
      <div className="flex items-center justify-between">
        {statusSteps.map((step, index) => {
          const isCompleted = index < actualIndex;
          const isCurrent = index === actualIndex;
          const isUpcoming = index > actualIndex;

          return (
            <div key={step} className="flex flex-col items-center relative flex-1">
              {/* Connector Line */}
              {index < statusSteps.length - 1 && (
                <div
                  className={`absolute top-5 left-1/2 w-full h-0.5 -z-10 ${
                    isCompleted ? 'bg-[#00A6E8]' : 'bg-slate-700'
                  }`}
                  style={{ width: 'calc(100% - 2rem)' }}
                />
              )}

              {/* Status Icon */}
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 transition-all ${
                  isCompleted
                    ? 'bg-[#00A6E8] text-[#0A0E1A]'
                    : isCurrent
                    ? 'bg-[#FFA726] text-[#0A0E1A] ring-4 ring-[#FFA726]/20'
                    : 'bg-slate-700 text-slate-400'
                }`}
              >
                {isCompleted ? (
                  <CheckCircle size={20} />
                ) : isCurrent ? (
                  <Clock size={20} />
                ) : (
                  <Circle size={20} />
                )}
              </div>

              {/* Status Label */}
              <p
                className={`text-xs font-semibold text-center ${
                  isCurrent ? 'text-[#FFA726]' : isCompleted ? 'text-[#00A6E8]' : 'text-slate-500'
                }`}
              >
                {step}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
